// extracted by mini-css-extract-plugin
module.exports = {"status":"ApplicationReviewsTable_status__3_hWm"};